import type * as Types from 'app/types/graphql';

export type OrderJourneySelectFragment = Pick<
  Types.OrderJourney,
  | 'campaignID'
  | 'campaignGroupID'
  | 'campaignGroupName'
  | 'campaignName'
  | 'campaignVariantType'
  | 'date'
  | 'locationPath'
  | 'name'
  | 'orderID'
  | 'pageTitle'
  | 'shopifySessionID'
> & {
  items?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.OrderJourneyItem,
          | 'imageURL'
          | 'productID'
          | 'productTitle'
          | 'productVariantID'
          | 'properties'
          | 'quantity'
          | 'title'
        >
      >
    >
  >;
};

export type OrderJourneyItemSelectFragment = Pick<
  Types.OrderJourneyItem,
  | 'imageURL'
  | 'productID'
  | 'productTitle'
  | 'productVariantID'
  | 'properties'
  | 'quantity'
  | 'title'
>;

export const OrderJourneyItemSelectFragmentDoc = `
    fragment OrderJourneyItemSelect on OrderJourneyItem {
  imageURL
  productID
  productTitle
  productVariantID
  properties
  quantity
  title
}
    `;
export const OrderJourneySelectFragmentDoc = `
    fragment OrderJourneySelect on OrderJourney {
  campaignID
  campaignGroupID
  campaignGroupName
  campaignName
  campaignVariantType
  date
  locationPath
  name
  orderID
  pageTitle
  shopifySessionID
  items {
    ...OrderJourneyItemSelect
  }
}
    `;
